import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { legalApi, LegalDocument } from '../services/api';

interface LegalPageProps {
  type: 'cgv' | 'cgu' | 'privacy_policy' | 'cookies_policy' | 'advertising_policy';
}

const titles: Record<string, string> = {
  cgv: 'Conditions Générales de Vente',
  cgu: "Conditions Générales d'Utilisation",
  privacy_policy: 'Politique de confidentialité',
  cookies_policy: 'Politique des cookies',
  advertising_policy: 'Politique de publicité',
};

export const LegalPage: React.FC<LegalPageProps> = ({ type }) => {
  const [document, setDocument] = useState<LegalDocument | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    legalApi
      .getDocument(type)
      .then((res) => setDocument(res.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [type]);

  return (
    <div className="legal-page">
      <div className="legal-page-header">
        <h1>{titles[type] ?? 'Document légal'}</h1>
      </div>

      <div className="legal-page-content">
        {loading && (
          <div className="legal-page-spinner">Chargement...</div>
        )}
        {!loading && error && (
          <p className="legal-page-error">Document non disponible.</p>
        )}
        {!loading && !error && document && (
          <ReactMarkdown>{document.content}</ReactMarkdown>
        )}
      </div>
    </div>
  );
};
